<p-dialog [(visible)]="chargeLineDialogVisible" [header]="chargeLineDialogHeader" [modal]="true"
    [style]="{ width: '86vw', 'max-width': '880px' }" [draggable]="false" [resizable]="false"
    (onShow)="onDialogShow()" (onHide)="hideChargeLineDialog()">
    <ng-container *ngIf="selectedChargeLine">
        <div class="p-fluid mt-3 charge-dialog-content">
            <div *ngIf="isReadOnlyLegacyCharge()" class="legacy-charge-notice">
                <i class="fa-solid fa-clock-rotate-left"></i>
                <div>
                    <strong>Legacy manual charge</strong>
                    <p>This LogiLink charge remains financially valid. Convert it to a catalog service before editing it.</p>
                </div>
                <p-button label="Replace with catalog service" icon="fa-solid fa-arrows-rotate"
                    (click)="convertLegacyCharge()"></p-button>
            </div>

            <app-page-form-section *ngIf="!isReadOnlyLegacyCharge()" icon="fa-solid fa-file-invoice-dollar"
                title="Add charge" subtitle="Choose where the charge applies, then enter its commercial value.">
                <div class="formgrid grid">
                    <div class="field col-12 delivery-scope-context" *ngIf="!isExistingCharge() && isDeliveryScoped()">
                        <i class="fa-solid fa-truck-fast"></i>
                        <span>Applies to delivery <strong>{{ selectedDelivery?.deliveryNumber || 'current delivery' }}</strong></span>
                    </div>
                    <div class="field col-12" *ngIf="!isExistingCharge() && !selectedDelivery">
                        <p-inputGroup>
                            <p-inputGroupAddon><i class="fa-solid fa-truck-ramp-box"></i></p-inputGroupAddon>
                            <p-iftaLabel>
                                <p-select inputId="allocationScope" [options]="allocationScopeOptions"
                                    [(ngModel)]="allocationScope" optionLabel="label" optionValue="value"
                                    (onChange)="onAllocationScopeChange()"
                                    styleClass="w-full"></p-select>
                                <label for="allocationScope">Apply charge to</label>
                            </p-iftaLabel>
                        </p-inputGroup>
                    </div>

                    <div class="field col-12" *ngIf="!isExistingCharge() && allocationScope === 'DELIVERIES' && !isDeliveryScoped()">
                        <p-inputGroup>
                            <p-inputGroupAddon><i class="fa-solid fa-truck-fast"></i></p-inputGroupAddon>
                            <p-iftaLabel>
                                <p-multiSelect inputId="deliveryIds" [options]="getAvailableDeliveriesForDropdown()"
                                    [(ngModel)]="selectedDeliveryIds" optionLabel="label" optionValue="value"
                                    [filter]="true" [showToggleAll]="true" [display]="'chip'"
                                    (onChange)="onDeliverySelectionChange()"
                                    placeholder="Select deliveries" styleClass="w-full"
                                    [ngClass]="{'ng-invalid ng-dirty': submittedChargeLine && selectedDeliveryIds.length === 0}">
                                </p-multiSelect>
                                <label for="deliveryIds">Deliveries *</label>
                            </p-iftaLabel>
                        </p-inputGroup>
                        <small class="selection-hint" *ngIf="selectedDeliveryIds.length">
                            {{ selectedDeliveryIds.length }} {{ selectedDeliveryIds.length === 1 ? 'delivery' : 'deliveries' }} will receive a separate charge line.
                        </small>
                    </div>

                    <div class="field col-12" *ngIf="isEnterpriseWorkspace()">
                        <p-inputGroup>
                            <p-inputGroupAddon><i class="fa-solid fa-box-open"></i></p-inputGroupAddon>
                            <p-iftaLabel>
                                <p-select inputId="catalogService" [options]="catalogOptions()"
                                    [(ngModel)]="selectedCatalogSelection" optionLabel="label" optionValue="value"
                                    [filter]="true" filterBy="label" [loading]="loadingChargeProducts"
                                    (onChange)="onCatalogSelectionChange()" styleClass="w-full"
                                    [ngClass]="{'ng-invalid ng-dirty': submittedChargeLine && !selectedChargeLine.productId}">
                                </p-select>
                                <label for="catalogService">Catalog service *</label>
                            </p-iftaLabel>
                            <p-inputGroupAddon class="quick-add-addon">
                                <button type="button" pButton icon="fa-solid fa-plus" class="p-button-text"
                                    pTooltip="Create shipment charge service" (click)="openProductDialog()"></button>
                            </p-inputGroupAddon>
                        </p-inputGroup>
                        <small class="p-error" *ngIf="submittedChargeLine && !selectedChargeLine.productId">Catalog service is required.</small>
                    </div>

                    <div class="field col-12" *ngIf="!isEnterpriseWorkspace()">
                        <p-inputGroup>
                            <p-inputGroupAddon><i class="fa-solid fa-tags"></i></p-inputGroupAddon>
                            <p-iftaLabel>
                                <p-select inputId="chargeType" [options]="chargeTypeOptions"
                                    [(ngModel)]="selectedChargeLine.chargeType" optionLabel="label" optionValue="value"
                                    [showClear]="true" styleClass="w-full"
                                    [ngClass]="{'ng-invalid ng-dirty': submittedChargeLine && !selectedChargeLine.chargeType}">
                                </p-select>
                                <label for="chargeType">Charge type *</label>
                            </p-iftaLabel>
                        </p-inputGroup>
                        <small class="p-error" *ngIf="submittedChargeLine && !selectedChargeLine.chargeType">Charge type is required.</small>
                    </div>

                    <div class="field col-12 delivery-pricing-grid" *ngIf="isBulkDeliveryPricing()">
                        <div class="delivery-pricing-grid__heading">
                            <div>
                                <strong>Delivery pricing</strong>
                                <span>Enter the cost and customer charge for each delivery.</span>
                            </div>
                            <p-button *ngIf="deliveryChargePricingRows.length > 1" label="Copy first row to all"
                                icon="fa-solid fa-copy" size="small" styleClass="p-button-text"
                                (click)="copyFirstDeliveryPricingToAll()"></p-button>
                        </div>
                        <div class="delivery-pricing-grid__table-wrap">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Delivery</th>
                                        <th>{{ costLabel() }}</th>
                                        <th>Customer charge</th>
                                        <th>Margin</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let row of deliveryChargePricingRows">
                                        <td><strong>{{ row.deliveryNumber }}</strong></td>
                                        <td>
                                            <p-inputNumber [inputId]="'deliveryBuying' + row.deliveryId"
                                                [(ngModel)]="row.buyingChargeAmount" mode="decimal"
                                                [minFractionDigits]="2" [maxFractionDigits]="2"
                                                (ngModelChange)="onDeliveryBuyingAmountChange(row, $event)"
                                                [ngClass]="{'ng-invalid ng-dirty': submittedChargeLine && row.buyingChargeAmount == null}">
                                            </p-inputNumber>
                                        </td>
                                        <td>
                                            <p-inputNumber [inputId]="'deliverySelling' + row.deliveryId"
                                                [(ngModel)]="row.sellingChargeAmount" mode="decimal"
                                                [minFractionDigits]="2" [maxFractionDigits]="2"
                                                (ngModelChange)="onDeliverySellingAmountChange(row, $event)"
                                                [ngClass]="{'ng-invalid ng-dirty': submittedChargeLine && row.sellingChargeAmount == null}">
                                            </p-inputNumber>
                                        </td>
                                        <td class="delivery-pricing-grid__margin"
                                            [class.is-negative]="deliveryMargin(row) < 0">
                                            {{ deliveryMargin(row) | number:'1.2-2' }} {{ selectedChargeLine.chargeCurrency || shipment.currencyCode }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <small class="p-error" *ngIf="submittedChargeLine && !hasValidDeliveryPricingRows()">
                            Each selected delivery needs a cost and customer charge of zero or greater.
                        </small>
                    </div>

                    <div class="field col-12 md:col-6" *ngIf="!isBulkDeliveryPricing() && !isInternalTransport()">
                        <p-inputGroup>
                            <p-inputGroupAddon><i class="fa-solid fa-arrow-down"></i></p-inputGroupAddon>
                            <p-iftaLabel>
                                <p-inputNumber inputId="buyingChargeAmount" [(ngModel)]="supplierBuyingAmount"
                                    mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2"
                                    (ngModelChange)="onSupplierBuyingAmountChange($event)"
                                    [ngClass]="{'ng-invalid ng-dirty': submittedChargeLine && supplierBuyingAmount == null}">
                                </p-inputNumber>
                                <label for="buyingChargeAmount">Supplier cost *</label>
                            </p-iftaLabel>
                        </p-inputGroup>
                    </div>

                    <div class="field col-12 md:col-6" *ngIf="!isBulkDeliveryPricing() && isInternalTransport()">
                        <p-inputGroup>
                            <p-inputGroupAddon><i class="fa-solid fa-building-columns"></i></p-inputGroupAddon>
                            <p-iftaLabel>
                                <p-inputNumber inputId="internalCostAmount" [(ngModel)]="internalCostAmount"
                                    mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2"
                                    (ngModelChange)="onInternalCostAmountChange($event)"
                                    [ngClass]="{'ng-invalid ng-dirty': submittedChargeLine && internalCostAmount == null}">
                                </p-inputNumber>
                                <label for="internalCostAmount">Internal cost *</label>
                            </p-iftaLabel>
                        </p-inputGroup>
                        <small class="selection-hint">Posts to Bulk Cost, not supplier payables.</small>
                    </div>

                    <div class="field col-12 md:col-6" *ngIf="!isBulkDeliveryPricing()">
                        <p-inputGroup>
                            <p-inputGroupAddon><i class="fa-solid fa-arrow-up"></i></p-inputGroupAddon>
                            <p-iftaLabel>
                                <p-inputNumber inputId="sellingChargeAmount" [(ngModel)]="selectedChargeLine.sellingChargeAmount"
                                    mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2"
                                    (ngModelChange)="updateOverrideFlags()"
                                    [ngClass]="{'ng-invalid ng-dirty': submittedChargeLine && selectedChargeLine.sellingChargeAmount == null}">
                                </p-inputNumber>
                                <label for="sellingChargeAmount">Customer charge *</label>
                            </p-iftaLabel>
                        </p-inputGroup>
                    </div>

                    <div class="field col-12">
                        <details class="charge-advanced-options">
                            <summary>More options</summary>
                            <div class="formgrid grid pt-3">
                                <div class="field col-12">
                                    <p-inputGroup>
                                        <p-inputGroupAddon><i class="fa-solid fa-calendar-days"></i></p-inputGroupAddon>
                                        <p-iftaLabel>
                                            <p-datePicker inputId="effectiveDate" [(ngModel)]="selectedEffectiveDate"
                                                dateFormat="yy-mm-dd" [showIcon]="false" styleClass="w-full">
                                            </p-datePicker>
                                            <label for="effectiveDate">Effective date</label>
                                        </p-iftaLabel>
                                    </p-inputGroup>
                                </div>
                                <div class="field col-12">
                                    <p-inputGroup>
                                        <p-inputGroupAddon><i class="fa-solid fa-pencil"></i></p-inputGroupAddon>
                                        <p-iftaLabel>
                                            <textarea pInputTextarea id="chargeNotes" [(ngModel)]="selectedChargeLine.remarks"
                                                rows="3" [required]="isMiscellaneousCharge()"
                                                [ngClass]="{'ng-invalid ng-dirty': submittedChargeLine && isMiscellaneousCharge() && !selectedChargeLine.remarks}"></textarea>
                                            <label for="chargeNotes">{{ isMiscellaneousCharge() ? 'Remarks *' : 'Notes (optional)' }}</label>
                                        </p-iftaLabel>
                                    </p-inputGroup>
                                </div>
                                <div class="field col-12" *ngIf="isEnterpriseWorkspace() && selectedProduct()">
                                    <div class="account-context">
                                        <div><span>Currency / tax</span><strong>{{ selectedProduct()?.currencyCode }} / {{ selectedProduct()?.taxRate ?? 0 }}%</strong></div>
                                        <div><span>Income account</span><strong>{{ selectedProduct()?.incomeAccountName || 'Company fallback' }}</strong></div>
                                        <div><span>Expense account</span><strong>{{ selectedProduct()?.expenseAccountName || 'Company fallback' }}</strong></div>
                                    </div>
                                </div>
                            </div>
                        </details>
                    </div>
                </div>
            </app-page-form-section>
        </div>
    </ng-container>
    <ng-template pTemplate="footer">
        <p-button label="Cancel" icon="fa-solid fa-xmark" styleClass="p-button-text"
            (click)="hideChargeLineDialog()"></p-button>
        <p-button *ngIf="!isReadOnlyLegacyCharge()" [label]="isExistingCharge() ? 'Update' : 'Save'"
            icon="fa-solid fa-check" (click)="saveChargeLine()" [loading]="saveChargeLineInProgress"
            [disabled]="saveChargeLineInProgress"></p-button>
    </ng-template>
</p-dialog>
